import { render, staticRenderFns } from "./InvoiceVendor.vue?vue&type=template&id=b2574910&scoped=true&"
import script from "./InvoiceVendor.vue?vue&type=script&lang=js&"
export * from "./InvoiceVendor.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceVendor.vue?vue&type=style&index=0&id=b2574910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2574910",
  null
  
)

export default component.exports